import {noop} from "lodash-es"
import {Feature} from "ol"
import {Point} from "ol/geom";
import {Coordinate} from "ol/coordinate"
import VectorLayer from "ol/layer/Vector"
import VectorSource from "ol/source/Vector"
import {Circle, Fill, Stroke, Style} from "ol/style"
import {TShortPoint} from "@ui/api/poi"
import poiService from "./features/PoiService"
import mapService from "./MapService"

export const filterLayer = new VectorLayer({
  updateWhileAnimating: true,
	source: new VectorSource<Feature<Point>>({
		features: [],
	}),
  style: (feature) => {
    const radius = feature.getProperties().radius
    if (radius) {
      const {resolution} = mapService.getAzimuthResolution()
      return new Style({
        geometry: feature.getGeometry() as Point,
        image: new Circle({
          radius: Math.round(radius / resolution),
          fill: new Fill({color: '#F0F2F555'}),
          stroke: new Stroke({color: 'black', width: 1}),
        })
      })
    }
    return new Style ({})
  },
  zIndex: 10000
})

export interface IPoiService {
  readonly selected?: number

  selectPoint(id: number): void
  unselectPoints(): void
  updatePointColor(id: number, color: number): void
  addPoint(coords: Coordinate, point: TShortPoint, toggleCallback: (id: number, select: boolean) => void): void
  removePoint(id: number): void

  setFilterPoint(coords: Coordinate, radius: number): void
  clearFilter(): void
}

export class PoiService implements IPoiService {

  constructor() {
    mapService.addLayer(filterLayer)
  }

  selectPoint(id: number) {
    poiService.getPoiLayerSource()?.getFeatures()
      .forEach(f => f.setProperties({selected: f.getProperties().id === id}))
  }

  unselectPoints() {
    poiService.getPoiLayerSource()?.getFeatures()
      .forEach(f => f.setProperties({selected: false}))
  }

  updatePointColor(id: number, color: number) {
    poiService.getPoiLayerSource()?.getFeatures()
      .forEach(f => f.getId() === id && f.setProperties({color}))
  }

  addPoint(coords: Coordinate, point: TShortPoint, toggleCallback: (id: number, select: boolean) => void = noop) {
    const feature = new Feature<Point>({
      geometry: new Point(coords),
    })
    feature.setId(point.id)
    feature.setProperties(point)
    feature.set("onClick", () => {
      const select = !feature.getProperties().selected
      toggleCallback(point.id, select)
    })
    poiService.getPoiLayerSource()?.addFeature(feature)
  }

  removePoint(id: number) {
    let feature = poiService.getPoiLayerSource()?.getFeatureById(id)
    feature && poiService.getPoiLayerSource()?.removeFeature(feature)
  }

  setFilterPoint(coords: Coordinate, radius: number) {
    filterLayer.getSource()?.clear()
    const feature = new Feature<Point>({geometry: new Point(coords)})
    feature.setProperties({radius})
    filterLayer.getSource()?.addFeature(feature)
  }

  clearFilter() {
    filterLayer.getSource()?.clear()
  }
}

export default new PoiService() as IPoiService
